import Layout from '../components/Layout'
import ProfileBody from '../components/ProfileBody'
import { useUser } from '../contexts/UserContext'

export default function Home() {
  const { user } = useUser()

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ProfileBody
          userId={user?.id}
          showBrowseTournaments
        />
      </div>
    </Layout>
  )
}
